
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { SidebarProvider } from "@/contexts/SidebarContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { ModalProvider } from "@/contexts/ModalContext";
// import { NotificationProvider } from "@/contexts/NotificationContext";
import AppRouter from "@/components/AppRouter";
import AuthDebug from "@/components/AuthDebug";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <AuthProvider>
        {/* <NotificationProvider>  TODO: ACTIVATE NOTIFICATIONS */}
          <SidebarProvider>
            <ModalProvider>
              <TooltipProvider>
                <Toaster />
                <Sonner />
                <HashRouter>
                  <AppRouter />
                </HashRouter>
                {/* <AuthDebug /> */}
              </TooltipProvider>
            </ModalProvider>
          </SidebarProvider>
        {/* </NotificationProvider> */}
      </AuthProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
